const SSRSafeElement =
  typeof Element === 'undefined' ? function ssrSafeElement() {} : Element;

export default SSRSafeElement;
